import React, { useEffect, useState } from 'react'
import { Col, Form, Image, Row, Table } from 'react-bootstrap'
import { useSearchParams } from 'react-router-dom'
import { Checkbox } from 'antd'
import styled from 'styled-components'
import ImgCheckbox from '../../../../images/checkbox.svg'
import TextDecodeHTML from '../../../text-html-br'
import { getChecklistNewFloorDetailAPI } from '../../../../services/checklist'
import Error_500 from '../../../error/error-500'
import moment from 'moment'

export default function StapPage4To1({ step, createDate }) {
  const detail = step?.result ?? []
  const dataGusto = detail.find((item) => item.equip_pd_group_id === 5) ?? {
    groups: []
  }

  const approve = step?.approve
  let [searchParams] = useSearchParams()
  const clnNo = searchParams.get('id')
  const [building, setBuilding] = useState([])
  const [building2, setBuilding2] = useState([])
  const [building3, setBuilding3] = useState([])
  const [building4, setBuilding4] = useState([])

  useEffect(() => {
    const getBuilding = async () => {
      try {
        const resp = await getChecklistNewFloorDetailAPI({
          clnNo
        })
        if (!resp) return
        if (resp.status) {
          setBuilding(resp.result.build1)
          setBuilding2(resp.result.build2)
          setBuilding3(resp.result.build3)
          setBuilding4(resp.result.build4)
        } else {
          setBuilding([])
          setBuilding2([])
          setBuilding3([])
          setBuilding4([])
        }
      } catch (error) {
        Error_500(error)
      }
    }
    if (clnNo) {
      getBuilding()
    }
  }, [clnNo])

  return (
    <>
      <div className="mt-2 mb-3">
        <span className="fw-bold ">เลขเอกสาร: </span>
        <span className="">{clnNo}</span>{' '}
        <span className="fw-light me-2 ">
          {createDate ? moment(createDate).format('DD/MM/YYYY HH:mm') : ''}
        </span>
      </div>
      {detail.length > 0 && (
        <Row>
          <Col xl={12}>
            <div className="fw-bold  mb-3">
              {' '}
              {detail.length > 0 && detail[0].equip_pd_group}
            </div>
            <Checkbox.Group
              style={{
                width: '100%'
              }}
            >
              <Row>
                <CheckboxRadioCustom className="fw-light">
                  {detail.length > 0 &&
                    detail[0].groups &&
                    detail[0].groups.length > 0 &&
                    detail[0].groups.map((d, i) => (
                      <div
                        className="form-check mb-3"
                        key={`subDescription${i}`}
                      >
                        <input
                          readOnly
                          checked={d.is_check === 0 ? false : true}
                          name={`group`}
                          type="radio"
                          id={`inline-radio-${i}`}
                          className="form-check-input"
                        />
                        <div>
                          <label
                            htmlFor={`inline-radio-${i}`}
                            className="form-check-label"
                          >
                            {d.equip_pd_name}
                          </label>

                          <TextDecodeHTML
                            text={d.equip_pd_detail}
                            style={{ marginLeft: '35px' }}
                            className="form-check-label mb-0"
                          />

                          {d.is_check !== 0 && (
                            <Table striped bordered style={{ width: 550 }}>
                              <thead>
                                <tr>
                                  <th colSpan={2} className="text-center">
                                    พื้นที่ปฏิบัติงาน*
                                  </th>
                                  <th colSpan={2} className="text-center">
                                    ลิฟต์
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="text-center">ตึกหน้า</td>
                                  <td className="text-center">ตึกหลัง</td>
                                  <td className="text-center">ตึกหน้า</td>
                                  <td className="text-center">ตึกหลัง</td>
                                </tr>
                                <tr>
                                  <td style={{ maxWidth: '80px' }}>
                                    <Checkbox.Group
                                      style={{
                                        width: '100%'
                                      }}
                                    >
                                      <CheckboxRadioCustom className="fw-light">
                                        {building.length > 0 &&
                                          building
                                            .sort((a, b) => a.id - b.id)
                                            .map((d, i) => (
                                              <Form.Check
                                                readOnly
                                                key={`building${d.id}${i}`}
                                                inline
                                                checked={
                                                  d.is_check === 0
                                                    ? false
                                                    : true
                                                }
                                                value={d.id}
                                                label={d.floor_name}
                                                name={`building`}
                                                type="radio"
                                              />
                                            ))}
                                      </CheckboxRadioCustom>
                                    </Checkbox.Group>
                                  </td>
                                  <td style={{ maxWidth: '80px' }}>
                                    <Checkbox.Group
                                      style={{
                                        width: '100%'
                                      }}
                                    >
                                      <CheckboxRadioCustom className="fw-light">
                                        {building2.length > 0 &&
                                          building2
                                            .sort((a, b) => a.id - b.id)
                                            .map((d, i) => (
                                              <Form.Check
                                                readOnly
                                                key={`building2${d.id}${i}`}
                                                inline
                                                checked={
                                                  d.is_check === 0
                                                    ? false
                                                    : true
                                                }
                                                label={d.floor_name}
                                                name={`building2`}
                                                type="radio"
                                              />
                                            ))}
                                      </CheckboxRadioCustom>
                                    </Checkbox.Group>
                                  </td>
                                  <td style={{ maxWidth: '80px' }}>
                                    <Checkbox.Group
                                      style={{
                                        width: '100%'
                                      }}
                                    >
                                      <CheckboxCustom className="fw-light">
                                        {building3.length > 0 &&
                                          building3
                                            .sort((a, b) => a.id - b.id)
                                            .map((d, i) => (
                                              <Form.Check
                                                readOnly
                                                key={`elevator1${d.id}${i}`}
                                                inline
                                                checked={
                                                  d.is_check === 0
                                                    ? false
                                                    : true
                                                }
                                                label={d.floor_name}
                                                name={`elevator1`}
                                                type="checkbox"
                                                value={d.id}
                                              />
                                            ))}
                                      </CheckboxCustom>
                                    </Checkbox.Group>
                                  </td>
                                  <td style={{ maxWidth: '80px' }}>
                                    <Checkbox.Group
                                      style={{
                                        width: '100%'
                                      }}
                                    >
                                      <CheckboxCustom className="fw-light">
                                        {building4.length > 0 &&
                                          building4
                                            .sort((a, b) => a.id - b.id)
                                            .map((d, i) => (
                                              <Form.Check
                                                readOnly
                                                key={`elevator2${d.id}${i}`}
                                                inline
                                                checked={
                                                  d.is_check === 0
                                                    ? false
                                                    : true
                                                }
                                                label={d.floor_name}
                                                name={`elevator2`}
                                                type="checkbox"
                                                value={d.id}
                                              />
                                            ))}
                                      </CheckboxCustom>
                                    </Checkbox.Group>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          )}
                        </div>
                      </div>
                    ))}
                </CheckboxRadioCustom>
              </Row>
            </Checkbox.Group>
          </Col>
          {dataGusto.groups.length > 0 && (
            <Col xl={12}>
              <div className="fw-bold  mb-3">{dataGusto?.equip_pd_group}</div>

              <Row className="g-2 mb-3">
                <Col xl={6}>
                  <CheckboxRadioCustom>
                    {dataGusto.groups.map((item) => (
                      <div
                        className="form-check mb-3"
                        key={item.id}
                        style={{ display: 'block', marginBottom: '8px' }}
                      >
                        <input
                          readOnly
                          type="radio"
                          name="radioGroup"
                          value={item.id}
                          className="form-check-input"
                          checked={item.is_check}
                        />
                        <div>
                          <label className="form-check-label">
                            {item.equip_pd_name}
                          </label>
                        </div>
                        {/* {item.is_check === 1 && (
                          <div className="mt-3">
                            <Form.Control
                              disabled
                              as="textarea"
                              value={
                                dataGusto.groups.find((item) => item.is_check)
                                  ?.detail ?? ''
                              }
                            />
                          </div>
                        )} */}
                      </div>
                    ))}
                  </CheckboxRadioCustom>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      )}

      {approve && (
        <div className=" mt-5 font-small-2 d-flex justify-content-center">
          <div style={{ width: 300 }}>
            <div className="d-flex justify-content-center">
              <Image width={250} fluid src={approve.url} />
            </div>
            <div className="d-flex justify-content-center">
              ลงชื่อ
              <div
                style={{
                  borderBottom: '1px dashed rgb(135, 135, 135)',
                  width: 200
                }}
              ></div>{' '}
              ผู้ดำเนินการ
            </div>
            <div className="d-flex justify-content-center mt-3">
              ({approve.title_th} {approve.name_th} {approve.surname_th})
            </div>
            <div className="d-flex justify-content-center fw-light mt-1">
              {approve.position_th}
            </div>
            <div className="d-flex justify-content-center fw-light">
              {moment(approve.confirm_date1).format('DD/MM/YYYY')}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const CheckboxRadioCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 1rem;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: "var(--comp-badge-color-background-primary)" !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid "var(--comp-badge-color-background-primary)";
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
  }
`

const CheckboxCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 4px !important;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: "var(--comp-badge-color-background-primary)" !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid "var(--comp-badge-color-background-primary)";
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
    margin-top: 0em;
  }
`
